// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ============================================
   RECIPE DETAIL MODAL - RECIPE KEEPER STYLE
   ============================================ */

/* Dialog container - full screen, no rounded corners */
.rk-recipe-detail-modal .MuiDialog-paper {
  background: #000000;
  border-radius: 0;
  max-width: 600px;
  margin: 0;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--wire-peach);
  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);
}

.rk-recipe-detail-modal .MuiDialog-container {
  height: 100%;
}

.rk-recipe-detail-modal .MuiBackdrop-root {
  background: rgba(0, 0, 0, 0.85);
}

/* Hero image section */
.rk-recipe-hero {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: #111;
}

.rk-recipe-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.rk-recipe-hero-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #444;
  background: #111;
}

.rk-recipe-hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

/* Top bar: back + actions */
.rk-recipe-hero-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.rk-hero-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--wire-peach);
  background: var(--btn-bg);
  color: var(--wire-peach);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);
}

.rk-hero-btn:hover {
  background: var(--btn-bg-hover);
  color: #fff;
  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18), 0 0 10px rgba(255, 217, 168, 0.4);
}

.rk-hero-btn-group {
  display: flex;
  gap: 8px;
}

/* Bottom: title + subtitle */
.rk-recipe-hero-bottom {
  padding: 16px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));
}

.rk-recipe-hero-title {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 6px 0;
  line-height: 1.2;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.rk-recipe-hero-subtitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.rk-hero-cat {
  color: rgba(255, 255, 255, 0.7);
}

/* Body content - scrollable */
.rk-recipe-body {
  padding: 16px 20px 40px;
  color: #ddd;
  font-size: 15px;
  line-height: 1.6;
  overflow-y: auto;
  flex: 1 1;
}

/* Meta row (source + servings) */
.rk-recipe-meta-row {
  margin-bottom: 16px;
}

.rk-recipe-meta-item {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
}

.rk-recipe-meta-label {
  color: #888;
  font-size: 13px;
  min-width: 80px;
}

.rk-recipe-source-link {
  color: #4a9eff;
  font-size: 13px;
  word-break: break-all;
  text-decoration: none;
}

.rk-recipe-source-link:hover {
  text-decoration: underline;
}

/* Serving adjuster - inline, always visible */
.rk-serving-adjuster {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: var(--panel-bg);
  border: 1px solid var(--wire-peach);
  border-radius: 10px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);
}

.rk-serving-adjuster-left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.rk-serving-label {
  font-size: 13px;
  color: #888;
  font-weight: 500;
}

.rk-serving-scale-badge {
  background: #e67e22;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1;
}

.rk-serving-adjuster-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.rk-serving-stepper {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid var(--wire-peach);
  background: var(--btn-bg);
  color: var(--wire-peach);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  padding: 0;
  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);
}

.rk-serving-stepper:hover {
  background: var(--btn-bg-hover);
  border-color: var(--wire-peach);
  color: #fff;
  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18), 0 0 10px rgba(255, 217, 168, 0.4);
}

.rk-serving-stepper:active {
  transform: scale(0.92);
}

.rk-serving-input-wrapper {
  width: 56px;
}

.rk-serving-input {
  width: 100%;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: rgba(255, 255, 255, 0.06);
  color: var(--wire-peach);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  outline: none;
  transition: all 0.15s ease;
  appearance: textfield;
  -moz-appearance: textfield;
}

.rk-serving-input::-webkit-outer-spin-button,
.rk-serving-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.rk-serving-input:focus {
  border-color: var(--wire-peach);
  background: var(--panel-bg);
  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18), 0 0 10px rgba(255, 217, 168, 0.4);
}

/* Preset buttons */
.rk-serving-presets {
  display: flex;
  gap: 4px;
  margin-left: auto;
}

.rk-serving-preset {
  height: 26px;
  padding: 0 8px;
  border-radius: 5px;
  border: 1px solid var(--wire-peach);
  background: var(--btn-bg);
  color: var(--wire-peach);
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);
}

.rk-serving-preset:hover {
  background: var(--btn-bg-hover);
  border-color: var(--wire-peach);
  color: #fff;
  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18), 0 0 10px rgba(255, 217, 168, 0.4);
}

.rk-serving-preset-active {
  background: var(--btn-bg-hover);
  border-color: var(--wire-peach);
  color: var(--wire-peach);
}

/* Legacy classes - no longer used but kept to avoid errors */
.rk-recipe-serving-text {
  color: #ddd;
}

.rk-recipe-adjust-link {
  display: none;
}

.rk-serving-adjuster-expanded {
  display: none;
}

.rk-serving-btn {
  display: none;
}

.rk-metric-toggle {
  border-radius: 4px;
  width: auto;
  padding: 0 8px;
  font-size: 12px;
  font-weight: 600;
  min-width: 45px;
}

.rk-metric-toggle-btn {
  border-radius: 4px;
  border: 1px solid #e67e22;
  background: transparent;
  color: #e67e22;
  font-size: 13px;
  font-weight: 600;
  padding: 4px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.rk-metric-toggle-btn:hover {
  background: rgba(230, 126, 34, 0.1);
}

.rk-metric-active {
  background: #e67e22;
  color: #fff;
  border-color: #e67e22;
}

/* Time info */
.rk-recipe-times {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
  font-size: 13px;
  color: #888;
}

.rk-recipe-times span {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Section titles */
.rk-recipe-section {
  margin-bottom: 24px;
}

.rk-recipe-section-title {
  color: #e67e22;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 12px 0;
}

/* Ingredients list - clean, no boxes */
.rk-ingredients-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.rk-ingredient-item {
  padding: 6px 0;
  font-size: 15px;
  color: #ddd;
  line-height: 1.5;
  border-bottom: 1px solid #1a1a1a;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: opacity 0.15s;
}

.rk-ingredient-item:last-child {
  border-bottom: none;
}

.rk-ingredient-checked {
  opacity: 0.35;
}

.rk-ingredient-amount {
  font-weight: 600;
  color: #fff;
  margin-right: 4px;
}

.rk-ingredient-name {
  color: #ddd;
}

.rk-ingredient-notes {
  color: #888;
  font-style: italic;
  font-size: 13px;
}

/* Directions - simple numbered steps */
.rk-directions-text {
  color: #ddd;
  line-height: 1.7;
}

.rk-direction-step {
  margin: 0 0 14px 0;
  font-size: 15px;
  line-height: 1.6;
  color: #ddd;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: font-weight 0.15s, color 0.15s;
}

.rk-direction-step:last-child {
  margin-bottom: 0;
}

.rk-direction-active {
  font-weight: 700;
  color: #fff;
}

.rk-direction-number {
  font-weight: 700;
  color: #e67e22;
  margin-right: 6px;
}

/* Notes */
.rk-notes-text {
  color: #aaa;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

/* No details state */
.rk-no-details {
  color: #666;
  font-style: italic;
  text-align: center;
  padding: 40px 20px;
}

/* Difficulty badge */
.rk-recipe-body .difficulty-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
}

/* Responsive */
@media (max-width: 600px) {
  .rk-recipe-detail-modal .MuiDialog-paper {
    max-width: 100%;
  }

  .rk-recipe-hero-title {
    font-size: 20px;
  }

  .rk-recipe-body {
    padding: 12px 16px 32px;
  }
}

/* ============================================
   RECIPE DETAIL PAGE - Full page view
   ============================================ */
.rk-recipe-page {
  max-width: 700px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.rk-recipe-page .rk-recipe-hero {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: #111;
  border-radius: 12px 12px 0 0;
}

.rk-recipe-page .rk-recipe-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.rk-recipe-page .rk-recipe-hero-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #444;
  background: #111;
}

.rk-recipe-page .rk-recipe-hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.rk-recipe-page .rk-recipe-hero-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.rk-recipe-page .rk-hero-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.rk-recipe-page .rk-hero-btn:hover {
  background: rgba(255, 255, 255, 0.4);
}

.rk-recipe-page .rk-hero-btn-group {
  display: flex;
  gap: 8px;
}

.rk-recipe-page .rk-recipe-hero-bottom {
  padding: 16px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));
}

.rk-recipe-page .rk-recipe-hero-title {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 6px 0;
  line-height: 1.2;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.rk-recipe-page .rk-recipe-hero-subtitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.rk-recipe-page .rk-hero-cat {
  color: rgba(255, 255, 255, 0.7);
}

.rk-recipe-page .rk-recipe-body {
  padding: 16px 20px 40px;
  color: #ddd;
  font-size: 15px;
  line-height: 1.6;
  flex: 1 1;
  background: #1a1a1a;
  border-radius: 0 0 12px 12px;
}

@media (max-width: 600px) {
  .rk-recipe-page {
    max-width: 100%;
  }
  .rk-recipe-page .rk-recipe-hero {
    border-radius: 0;
  }
  .rk-recipe-page .rk-recipe-hero-title {
    font-size: 20px;
  }
  .rk-recipe-page .rk-recipe-body {
    padding: 12px 14px 30px;
    border-radius: 0;
  }
}

/* Metric unit toggle link on ingredient */
.rk-ingredient-unit-toggle {
  color: #e67e22;
  font-size: 11px;
  cursor: pointer;
  margin-left: 4px;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.rk-ingredient-unit-toggle:hover {
  opacity: 1;
}

/* Metric context menu */
.rk-metric-context-menu {
  position: fixed;
  z-index: 10000;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 4px 0;
  min-width: 180px;
}

.rk-metric-menu-title {
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #888;
  border-bottom: 1px solid #eee;
  margin-bottom: 2px;
  text-transform: capitalize;
}

.rk-metric-menu-item {
  display: block;
  width: 100%;
  padding: 8px 14px;
  border: none;
  background: transparent;
  text-align: left;
  font-size: 13px;
  color: #333;
  cursor: pointer;
  transition: background 0.15s;
}

.rk-metric-menu-item:hover {
  background: #f5f5f5;
}

.rk-metric-menu-active {
  background: #e8f5e9;
  font-weight: 600;
  color: #2e7d32;
}

.rk-metric-menu-copy {
  color: #e67e22 !important;
  font-weight: 600;
}

.rk-metric-menu-divider {
  height: 1px;
  background: #eee;
  margin: 4px 0;
}

.rk-metric-menu-subtitle {
  padding: 4px 14px;
  font-size: 11px;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.rk-metric-menu-active {
  color: #e67e22;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/RecipeBook/RecipeBook-modal.css"],"names":[],"mappings":";AACA;;iDAEiD;;AAEjD,uDAAuD;AACvD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,wFAAwF;AAC1F;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;AACT;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,wFAAwF;AAC1F;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,wFAAwF;AAC1F;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,wFAAwF;AAC1F;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,6DAA6D;AAC7D;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;;iDAEiD;AACjD;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA,0CAA0C;AAC1C;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["\n/* ============================================\n   RECIPE DETAIL MODAL - RECIPE KEEPER STYLE\n   ============================================ */\n\n/* Dialog container - full screen, no rounded corners */\n.rk-recipe-detail-modal .MuiDialog-paper {\n  background: #000000;\n  border-radius: 0;\n  max-width: 600px;\n  margin: 0;\n  min-height: 100vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--wire-peach);\n  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);\n}\n\n.rk-recipe-detail-modal .MuiDialog-container {\n  height: 100%;\n}\n\n.rk-recipe-detail-modal .MuiBackdrop-root {\n  background: rgba(0, 0, 0, 0.85);\n}\n\n/* Hero image section */\n.rk-recipe-hero {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  overflow: hidden;\n  background: #111;\n}\n\n.rk-recipe-hero img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.rk-recipe-hero-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #444;\n  background: #111;\n}\n\n.rk-recipe-hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n/* Top bar: back + actions */\n.rk-recipe-hero-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n}\n\n.rk-hero-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid var(--wire-peach);\n  background: var(--btn-bg);\n  color: var(--wire-peach);\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);\n}\n\n.rk-hero-btn:hover {\n  background: var(--btn-bg-hover);\n  color: #fff;\n  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18), 0 0 10px rgba(255, 217, 168, 0.4);\n}\n\n.rk-hero-btn-group {\n  display: flex;\n  gap: 8px;\n}\n\n/* Bottom: title + subtitle */\n.rk-recipe-hero-bottom {\n  padding: 16px;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));\n}\n\n.rk-recipe-hero-title {\n  color: #fff;\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0 0 6px 0;\n  line-height: 1.2;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.rk-recipe-hero-subtitle {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 14px;\n}\n\n.rk-hero-cat {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Body content - scrollable */\n.rk-recipe-body {\n  padding: 16px 20px 40px;\n  color: #ddd;\n  font-size: 15px;\n  line-height: 1.6;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Meta row (source + servings) */\n.rk-recipe-meta-row {\n  margin-bottom: 16px;\n}\n\n.rk-recipe-meta-item {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.rk-recipe-meta-label {\n  color: #888;\n  font-size: 13px;\n  min-width: 80px;\n}\n\n.rk-recipe-source-link {\n  color: #4a9eff;\n  font-size: 13px;\n  word-break: break-all;\n  text-decoration: none;\n}\n\n.rk-recipe-source-link:hover {\n  text-decoration: underline;\n}\n\n/* Serving adjuster - inline, always visible */\n.rk-serving-adjuster {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  background: var(--panel-bg);\n  border: 1px solid var(--wire-peach);\n  border-radius: 10px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);\n}\n\n.rk-serving-adjuster-left {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.rk-serving-label {\n  font-size: 13px;\n  color: #888;\n  font-weight: 500;\n}\n\n.rk-serving-scale-badge {\n  background: #e67e22;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 4px;\n  line-height: 1;\n}\n\n.rk-serving-adjuster-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.rk-serving-stepper {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  border: 1px solid var(--wire-peach);\n  background: var(--btn-bg);\n  color: var(--wire-peach);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n  padding: 0;\n  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);\n}\n\n.rk-serving-stepper:hover {\n  background: var(--btn-bg-hover);\n  border-color: var(--wire-peach);\n  color: #fff;\n  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18), 0 0 10px rgba(255, 217, 168, 0.4);\n}\n\n.rk-serving-stepper:active {\n  transform: scale(0.92);\n}\n\n.rk-serving-input-wrapper {\n  width: 56px;\n}\n\n.rk-serving-input {\n  width: 100%;\n  height: 28px;\n  border-radius: 6px;\n  border: none;\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--wire-peach);\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  outline: none;\n  transition: all 0.15s ease;\n  appearance: textfield;\n  -moz-appearance: textfield;\n}\n\n.rk-serving-input::-webkit-outer-spin-button,\n.rk-serving-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.rk-serving-input:focus {\n  border-color: var(--wire-peach);\n  background: var(--panel-bg);\n  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18), 0 0 10px rgba(255, 217, 168, 0.4);\n}\n\n/* Preset buttons */\n.rk-serving-presets {\n  display: flex;\n  gap: 4px;\n  margin-left: auto;\n}\n\n.rk-serving-preset {\n  height: 26px;\n  padding: 0 8px;\n  border-radius: 5px;\n  border: 1px solid var(--wire-peach);\n  background: var(--btn-bg);\n  color: var(--wire-peach);\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18);\n}\n\n.rk-serving-preset:hover {\n  background: var(--btn-bg-hover);\n  border-color: var(--wire-peach);\n  color: #fff;\n  box-shadow: inset 0 0 0 1px rgba(255, 217, 168, 0.18), 0 0 10px rgba(255, 217, 168, 0.4);\n}\n\n.rk-serving-preset-active {\n  background: var(--btn-bg-hover);\n  border-color: var(--wire-peach);\n  color: var(--wire-peach);\n}\n\n/* Legacy classes - no longer used but kept to avoid errors */\n.rk-recipe-serving-text {\n  color: #ddd;\n}\n\n.rk-recipe-adjust-link {\n  display: none;\n}\n\n.rk-serving-adjuster-expanded {\n  display: none;\n}\n\n.rk-serving-btn {\n  display: none;\n}\n\n.rk-metric-toggle {\n  border-radius: 4px;\n  width: auto;\n  padding: 0 8px;\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 45px;\n}\n\n.rk-metric-toggle-btn {\n  border-radius: 4px;\n  border: 1px solid #e67e22;\n  background: transparent;\n  color: #e67e22;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 4px 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.rk-metric-toggle-btn:hover {\n  background: rgba(230, 126, 34, 0.1);\n}\n\n.rk-metric-active {\n  background: #e67e22;\n  color: #fff;\n  border-color: #e67e22;\n}\n\n/* Time info */\n.rk-recipe-times {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 20px;\n  font-size: 13px;\n  color: #888;\n}\n\n.rk-recipe-times span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Section titles */\n.rk-recipe-section {\n  margin-bottom: 24px;\n}\n\n.rk-recipe-section-title {\n  color: #e67e22;\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0 0 12px 0;\n}\n\n/* Ingredients list - clean, no boxes */\n.rk-ingredients-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.rk-ingredient-item {\n  padding: 6px 0;\n  font-size: 15px;\n  color: #ddd;\n  line-height: 1.5;\n  border-bottom: 1px solid #1a1a1a;\n  cursor: pointer;\n  user-select: none;\n  transition: opacity 0.15s;\n}\n\n.rk-ingredient-item:last-child {\n  border-bottom: none;\n}\n\n.rk-ingredient-checked {\n  opacity: 0.35;\n}\n\n.rk-ingredient-amount {\n  font-weight: 600;\n  color: #fff;\n  margin-right: 4px;\n}\n\n.rk-ingredient-name {\n  color: #ddd;\n}\n\n.rk-ingredient-notes {\n  color: #888;\n  font-style: italic;\n  font-size: 13px;\n}\n\n/* Directions - simple numbered steps */\n.rk-directions-text {\n  color: #ddd;\n  line-height: 1.7;\n}\n\n.rk-direction-step {\n  margin: 0 0 14px 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: #ddd;\n  cursor: pointer;\n  user-select: none;\n  transition: font-weight 0.15s, color 0.15s;\n}\n\n.rk-direction-step:last-child {\n  margin-bottom: 0;\n}\n\n.rk-direction-active {\n  font-weight: 700;\n  color: #fff;\n}\n\n.rk-direction-number {\n  font-weight: 700;\n  color: #e67e22;\n  margin-right: 6px;\n}\n\n/* Notes */\n.rk-notes-text {\n  color: #aaa;\n  font-size: 14px;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* No details state */\n.rk-no-details {\n  color: #666;\n  font-style: italic;\n  text-align: center;\n  padding: 40px 20px;\n}\n\n/* Difficulty badge */\n.rk-recipe-body .difficulty-badge {\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .rk-recipe-detail-modal .MuiDialog-paper {\n    max-width: 100%;\n  }\n\n  .rk-recipe-hero-title {\n    font-size: 20px;\n  }\n\n  .rk-recipe-body {\n    padding: 12px 16px 32px;\n  }\n}\n\n/* ============================================\n   RECIPE DETAIL PAGE - Full page view\n   ============================================ */\n.rk-recipe-page {\n  max-width: 700px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.rk-recipe-page .rk-recipe-hero {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  overflow: hidden;\n  background: #111;\n  border-radius: 12px 12px 0 0;\n}\n\n.rk-recipe-page .rk-recipe-hero img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.rk-recipe-page .rk-recipe-hero-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #444;\n  background: #111;\n}\n\n.rk-recipe-page .rk-recipe-hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.rk-recipe-page .rk-recipe-hero-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n}\n\n.rk-recipe-page .rk-hero-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255, 255, 255, 0.25);\n  color: #fff;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.rk-recipe-page .rk-hero-btn:hover {\n  background: rgba(255, 255, 255, 0.4);\n}\n\n.rk-recipe-page .rk-hero-btn-group {\n  display: flex;\n  gap: 8px;\n}\n\n.rk-recipe-page .rk-recipe-hero-bottom {\n  padding: 16px;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));\n}\n\n.rk-recipe-page .rk-recipe-hero-title {\n  color: #fff;\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0 0 6px 0;\n  line-height: 1.2;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.rk-recipe-page .rk-recipe-hero-subtitle {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 14px;\n}\n\n.rk-recipe-page .rk-hero-cat {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.rk-recipe-page .rk-recipe-body {\n  padding: 16px 20px 40px;\n  color: #ddd;\n  font-size: 15px;\n  line-height: 1.6;\n  flex: 1;\n  background: #1a1a1a;\n  border-radius: 0 0 12px 12px;\n}\n\n@media (max-width: 600px) {\n  .rk-recipe-page {\n    max-width: 100%;\n  }\n  .rk-recipe-page .rk-recipe-hero {\n    border-radius: 0;\n  }\n  .rk-recipe-page .rk-recipe-hero-title {\n    font-size: 20px;\n  }\n  .rk-recipe-page .rk-recipe-body {\n    padding: 12px 14px 30px;\n    border-radius: 0;\n  }\n}\n\n/* Metric unit toggle link on ingredient */\n.rk-ingredient-unit-toggle {\n  color: #e67e22;\n  font-size: 11px;\n  cursor: pointer;\n  margin-left: 4px;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n\n.rk-ingredient-unit-toggle:hover {\n  opacity: 1;\n}\n\n/* Metric context menu */\n.rk-metric-context-menu {\n  position: fixed;\n  z-index: 10000;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  padding: 4px 0;\n  min-width: 180px;\n}\n\n.rk-metric-menu-title {\n  padding: 8px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #888;\n  border-bottom: 1px solid #eee;\n  margin-bottom: 2px;\n  text-transform: capitalize;\n}\n\n.rk-metric-menu-item {\n  display: block;\n  width: 100%;\n  padding: 8px 14px;\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-size: 13px;\n  color: #333;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.rk-metric-menu-item:hover {\n  background: #f5f5f5;\n}\n\n.rk-metric-menu-active {\n  background: #e8f5e9;\n  font-weight: 600;\n  color: #2e7d32;\n}\n\n.rk-metric-menu-copy {\n  color: #e67e22 !important;\n  font-weight: 600;\n}\n\n.rk-metric-menu-divider {\n  height: 1px;\n  background: #eee;\n  margin: 4px 0;\n}\n\n.rk-metric-menu-subtitle {\n  padding: 4px 14px;\n  font-size: 11px;\n  color: #999;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.rk-metric-menu-active {\n  color: #e67e22;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
